import { Component,ViewChild, Injector } from '@angular/core';
import {ModalController, Platform} from '@ionic/angular';
import {TourGuideManagerProvider} from '../../providers/tour-guide-manager/tour-guide-manager';

import JQuery from 'jquery';
import { CommonModule } from '@angular/common';

/**
 * Generated class for the TourGuideComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'tour-guide',
  templateUrl: 'tour-guide.html',
  styleUrls: ['tour-guide.scss'],
  standalone: true,
  imports:[CommonModule]
})
export class TourGuideComponent {
  @ViewChild('chatInput', { static: false }) chatInput;
  text: string;
  width = '0px';
  height = '0px';
  top = '0px';
  left = '0px';
  textWidth = '84vw';
  textHeight = 'auto';
  textTop = '40vh';
  textLeft = '20px';
  buttonLeft = '20px';
  buttonTop = '20px';
  currentTip :Tip;
  public tourGuideMgr : TourGuideManagerProvider;
  constructor(
    
  ) {
    
//    this.text = this.tourGuideMgr.getTip().text;
    this.next();
  }
  next(){
      if (this.tourGuideMgr.tips.length == 0)
          this.close();
      else {
            this.currentTip = this.tourGuideMgr.getTip();
            this.text = this.currentTip.text;
            if (this.currentTip.element && this.currentTip.element.length > 0){
                this.focusOnElement();
            }
      }

  }
  clickAndNext(){
    if(this.currentTip && this.currentTip.element){
        this.currentTip.element.click();
        if(this.tourGuideMgr.tips.length == 0){
            this.setUserLearned(true);
        }
    }
    this.next();
  }
  setUserLearned(learned : boolean){
    // this.userLearned = learned;
  }
  close(){
      // this.viewCtrl.dismiss({userLearned : this.userLearned});
  }
  gotIt(){
    this.close();

    //   this.tourGuideMgr.getCurrentTutorial().setRepeat(false);
  }
  ionViewDidLoad(){
  }
  ngOnChanges(){

    

    
  }
  canButtonGotShow(){
    return this.tourGuideMgr.tips.length == 0;
  }
  focusOnElement(){
      this.width = this.currentTip.element.width()+5+"px";
      this.height = this.currentTip.element.height()+5+"px";
      if (this.currentTip.width != undefined){
          this.width = this.currentTip.width + "px";
          this.height = this.currentTip.height+ "px";
      }
      this.top = this.currentTip.element.offset().top-2+"px";
      this.left = this.currentTip.element.offset().left-2+"px";
      // let text = $("<div style='font-size:19px; font-family: Yekan;font-weight: bold; width:84vw; height:auto; padding:10px'>" + this.text+"</div>");
      //  $("body").append(text);
       
      //  let heightDiff = this.currentTip.element.offset().top - text.height();

//        if (heightDiff < 10) {
//            this.textTop = this.currentTip.element.height()+10+"px";
//        }else{
//                this.textTop = -text.height() -20+"px";
//        }
// //       this.textLeft = "10%";
//        if (this.currentTip.element.offset().left + text.width() > this.platform.width()){
//            this.textLeft = this.platform.width() - this.currentTip.element.offset().left- text.width() -10 +"px";
//        }
      //  else if(this.currentTip.element.offset().left< 10)
      //        this.textLeft = this.currentTip.element.offset().left+"px";

       this.buttonTop = this.currentTip.element.height + this.top + 5 +"px";

       

        
  }
}
export interface Tip {
    element : JQuery,
    text : string,
    width?: number,
    height?: number
    
}